<template>
    <div class="not-found-container d-flex flex-column justify-content-center align-items-center vh-100">
        <h1 class="display-1 fw-bold text-primary">404</h1>
        <h2 class="text-muted">Oops! Page not found.</h2>
        <p class="text-center text-secondary">
            The page you're looking for doesn't exist or has been moved.
        </p>
        <router-link to="/" class="btn btn-primary mt-3">Go Home</router-link>
    </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
    name: "NotFound",
});
</script>

<style scoped>
.not-found-container {
    text-align: center;
}
</style>